import { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal from "./deletepopup";
import Placeholder from "react-bootstrap/Placeholder";

import {
  getHotel,
  deleteHotel,
} from "../../store/slices/hotel";

export default function HotelList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { hotelLists = [] } = useSelector((state) => state.hotel);

  const [currentPage, setCurrentPage] = useState(1);
  const pageLimit = 10;
  const [loading, setLoading] = useState(true);

  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");

  const fetchHotels = async () => {
    try {
      await dispatch(getHotel()).unwrap();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHotels();
    console.log(hotelLists)
  }, []);

  const hotelList = Array.isArray(hotelLists) ? hotelLists : [];
  const totalPages = Math.ceil(hotelList.length / pageLimit);

  const startIndex = (currentPage - 1) * pageLimit;
  const currentHotels = hotelList.slice(startIndex, startIndex + pageLimit);

  // handledelete
  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      console.log("Selected ID:", selectedId);
      console.log("before, dispatch ")
      await dispatch(deleteHotel(selectedId)).unwrap();
      console.log("after dispath")
      setDeleteStatus("success");

      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);

    } catch (error) {
      console.error("Delete failed FULL ERROR:", error);
      setDeleteStatus("confirm");
    }
  };


  const SkeletonCard = () => (
    <Col lg={4} md={6} sm={12} className="mb-4">
      <Card
        className="h-100 border-0"
        style={{
          borderRadius: "18px",
          overflow: "hidden",
        }}
      >
        <Placeholder
          as="div"
          animation="wave"
          style={{ height: "200px", backgroundColor: "#e9ecef" }}
        />
        <Card.Body className="p-3">
          <Placeholder as="h6" animation="wave">
            <Placeholder xs={8} />
          </Placeholder>
          <Placeholder as="p" animation="wave" className="mb-0">
            <Placeholder xs={10} />
          </Placeholder>
        </Card.Body>
      </Card>
    </Col>
  );

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/hotel/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/hotel/hotellist")}
          >
            Hotel List
          </span>
        </div>

        <Button
          className="add-outlet-btn"
          onClick={() => navigate("/hotel/addhotellist")}
        >
          + Add New
        </Button>
      </div>

      <Container className="my-2">
        <Row>
          {loading
            ? Array.from({ length: 6 }).map((_, index) => (
              <SkeletonCard key={index} />
            ))
            : currentHotels.map((hotel) => (
              <Col lg={4} md={6} sm={12} key={hotel._id} className="mb-4">
                <Card
                  className="h-100 hotel-card border-0"
                  style={{
                    borderRadius: "18px",
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                  }}
                >
                  <div className="hotel-img-wrapper">
                    <Card.Img
                      src={hotel.image}
                      alt={hotel.name}
                      className="hotel-img"
                    />

                    <div className="hotel-actions">
                      <FaEdit
                        size={25}
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/hotel/edithotellist/${hotel._id}`)
                        }
                      />
                      <FaTrash
                        size={25}
                        style={{ color: "red", cursor: "pointer" }}
                        onClick={() => {
                          setSelectedId(hotel._id);
                          setShowDelete(true);
                        }}
                      />
                    </div>
                  </div>

                  {/* Body */}
                  <Card.Body className="p-3">
                    <span
                      onClick={() =>
                        navigate(`/hotel/hoteldetails/${hotel._id}`)
                      }
                      state={{ hotel }}
                      style={{ cursor: "pointer" }}
                      className="text-decoration-none text-dark"
                    >
                      <h6 className="fw-semibold mb-1 hotel-title">
                        {hotel.name}
                      </h6>
                    </span>

                    <p className="text-muted mb-0 hotel-address">
                      {hotel.location?.name}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
        </Row>
        {!loading && totalPages > 1 && (
          <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
            <Button
              variant="light"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              ‹
            </Button>

            {[...Array(totalPages)].map((_, index) => (
              <Button
                key={index}
                variant={currentPage === index + 1 ? "dark" : "light"}
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </Button>
            ))}

            <Button
              variant="light"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              ›
            </Button>
          </div>
        )}
      </Container>

      {/* delete model */}
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
